module.exports = ".vehicle-image {\n  border: 2px solid #ffffff;\n  border-radius: 4px;\n}\n\n.vehicle-image:hover {\n  border: 2px solid #1e88e5;\n}\n"